module.exports = __webpack_public_path__ + "img/search.77ab9d6f.svg";